export const SCHEDULE_LABEL = 'Last Friday of Every Month'
export const SCHEDULE_LABEL_SHORT = 'Last Friday Monthly'
export const SCHEDULE_SERIES_NAME = 'SMA Monthly Masterclass'

/** Rotation anchor: August 2026 → first speaker (Herbert). */
export const ROTATION_START = { year: 2026, month: 8 }

export function getLastFridayOfMonth(year, month) {
  // month is 1-indexed in this utility (January = 1)
  const lastDay = new Date(year, month, 0).getDate()
  for (let d = lastDay; d > 0; d--) {
    const date = new Date(year, month - 1, d)
    if (date.getDay() === 5) {
      date.setHours(17, 0, 0, 0)
      return date
    }
  }
  return null
}

// Keep old name as alias for backward compatibility
export const getFirstFridayOfMonth = getLastFridayOfMonth

export function getNextLastFriday(fromDate = new Date()) {
  const now = new Date(fromDate)
  let candidate = getLastFridayOfMonth(now.getFullYear(), now.getMonth() + 1)
  if (!candidate || candidate <= now) {
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    candidate = getLastFridayOfMonth(nextMonth.getFullYear(), nextMonth.getMonth() + 1)
  }
  return candidate
}

// Keep old name as alias
export const getNextFirstFriday = getNextLastFriday

export function getCountdownTarget(eventDate) {
  if (eventDate) {
    const d = new Date(eventDate)
    d.setHours(17, 0, 0, 0)
    if (d > new Date()) return d
  }
  return getNextLastFriday()
}

export function formatScheduleFallback() {
  return SCHEDULE_LABEL
}

export function pickRecentPastSession(sessions) {
  if (!sessions?.length) return null
  const completed = sessions.filter(s => s.status === 'completed')
  if (completed.length) return completed[0]
  const manual = sessions.find(s => s.topic && !s.topic.includes('SMA Monthly Masterclass with'))
  return manual || sessions[0]
}

export function isValidEventDate(d) {
  return d && !Number.isNaN(new Date(d).getTime())
}

export function toISODateString(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** Suggest the last Friday of the month after a source session date. */
export function getSuggestedCloneDate(sourceEventDate) {
  const base = sourceEventDate ? new Date(sourceEventDate) : new Date()
  const nextMonth = new Date(base.getFullYear(), base.getMonth() + 1, 1)
  const lastFri = getLastFridayOfMonth(nextMonth.getFullYear(), nextMonth.getMonth() + 1)
  return lastFri ? toISODateString(lastFri) : toISODateString(nextMonth)
}
